export default "__VITE_ASSET__BAkCrzi0__"